import { ModelsNewsMediaBlock } from '@/api/generated-api'

export function getNewsMediaBlockBySlot(
  blocks: ModelsNewsMediaBlock[] | undefined,
  slot: number
): ModelsNewsMediaBlock | undefined {
  return blocks?.find(block => block.slot === slot)
}
